/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 */

import { styled } from '@mui/material/styles';
import Icon from '../icons/Icon';

const DashboardCardIcon = styled(Icon)({
  '&&': {
    width: '16px',
    height: '16px',
    fontSize: '16px'
  }
});

export default DashboardCardIcon;
